import { render } from "./AllDeletedProducts.vue?vue&type=template&id=57b4f05a"
import script from "./AllDeletedProducts.vue?vue&type=script&lang=js"
export * from "./AllDeletedProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__